import React from "react";
import "./payment.css";
const Payment = () => {
  return (
    <div className="payment d-flex justify-content-center align-items-center">
      <h1>payment is coming soon</h1>
    </div>
  );
};

export default Payment;
